import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "@/utils/trpc"

export const getAddressOptions = (sessionId: string) => trpcOptions.sessions.getAddress.queryOptions({ sessionId })

export function useGetAddress(sessionId: string) {
  return useQuery(getAddressOptions(sessionId))
}
